import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  {
    headerName: 'Employee ID',
    field: 'employeeId',
    width: LIST_WIDTH.md,
  },
  {
    headerName: 'Name',
    field: 'employeeName',
    width: LIST_WIDTH.lg,
  },
  {
    headerName: 'Shift Status',
    field: 'shiftStatus',
    cellRenderer: 'activityComponent',
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'Start Shift',
    field: 'startShift',
    width: LIST_WIDTH.md,
  },
  {
    headerName: 'End Shift',
    field: 'endShift',
    width: LIST_WIDTH.md,
  },
  {
    headerName: 'Duration',
    field: 'duration',
    width: LIST_WIDTH.md,
  },
  {
    headerName: 'Reporter',
    field: 'reporterName',
    width: LIST_WIDTH.lg,
  },
  {
    field: 'departments',
    headerName: 'Departments',
    width: LIST_WIDTH.sm,
  },
];
